// extracted by mini-css-extract-plugin
module.exports = {"amp-config-title":"advertisement-config_amp-config-title__1545T","amp-config-description":"advertisement-config_amp-config-description__1o978"};